import { getConfig } from './runtime'

export const AUTH_CONFIG = {
  get domain() { return getConfig().auth.auth0.domain },
  get client_id() { return getConfig().auth.auth0.clientId },
  get audience() { return getConfig().auth.auth0.audience },
  get returnTo() { return getConfig().auth.auth0.returnTo },
}
